import { render, staticRenderFns } from "./PhoneInputConfig.vue?vue&type=template&id=dbf10ed0&scoped=true"
import script from "./PhoneInputConfig.vue?vue&type=script&lang=js"
export * from "./PhoneInputConfig.vue?vue&type=script&lang=js"
import style0 from "./PhoneInputConfig.vue?vue&type=style&index=0&id=dbf10ed0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf10ed0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbf10ed0')) {
      api.createRecord('dbf10ed0', component.options)
    } else {
      api.reload('dbf10ed0', component.options)
    }
    module.hot.accept("./PhoneInputConfig.vue?vue&type=template&id=dbf10ed0&scoped=true", function () {
      api.rerender('dbf10ed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/config/PhoneInputConfig.vue"
export default component.exports